import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { RootState } from "../index";
import { artistsApi } from "../../repositories/artists";
import { ArtistData } from "../../components/types/artists";
import Swal from "sweetalert2";

interface ArtistsState {
  artistsData: ArtistData[];
  loading: boolean;
}

const initialState: ArtistsState = {
  artistsData: [],
  loading: false,
};

// Async thunk for fetching artists
export const fetchArtists = createAsyncThunk(
  "artists/fetchArtists",
  async () => {
    try {
      const response = await artistsApi.getAll();
      return response.data.data.artists || [];
    } catch (error: any) {
      if (error.response?.status === 404) {
        return [];
      }
      Swal.fire(
        "Error",
        error?.response?.data?.message ||
        error.message ||
        "An unknown error occurred",
        "error"
      );
      return [];
    }
  }
);

export const artistsSlice = createSlice({
  name: "artists",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArtists.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchArtists.fulfilled, (state, action) => {
        state.loading = false;
        state.artistsData = action.payload;
      });
  },
});

export const selectArtists = (state: RootState) => state.artists.artistsData;
export const selectArtistsLoading = (state: RootState) => state.artists.loading;

export default artistsSlice.reducer;
